import { css } from '@mui/material'

export const hideEmptyCss = css`
  :empty {
    display: none;
  }
`
